<template>
  <div v-if="currentNas != null" id="show-logradius">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Filtres </v-card-title>
          <v-card-text @keyup.enter="updateSearchTerm">
            <v-form>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="Login"
                    single-line
                    v-model="datatableProxyFilters.username"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="datatableProxyFilters.createdAt"
                        label="From"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="datatableProxyFilters.createdAt"
                      @input="dateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-select
                    label="Operation"
                    single-line
                    v-model="datatableProxyFilters.operation"
                    :items="operationChoices"
                    multiple
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-select
                    multiple
                    label="Type"
                    single-line
                    v-model="datatableProxyFilters.replyPacketType"
                    :items="replyChoices"
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-select
                    label="Acc cause"
                    single-line
                    multiple
                    v-model="datatableProxyFilters.accountTerminateCause"
                    :items="accountTerminateCauseChocies"
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-select
                    label="Acc status"
                    single-line
                    multiple
                    v-model="datatableProxyFilters.accountStatusType"
                    :items="accountStatusTypeChoices"
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Calling ID"
                    single-line
                    v-model="datatableProxyFilters.callingStationId"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="IP"
                    single-line
                    v-model="datatableProxyFilters.clientIpAddress"
                  ></v-text-field>
                </v-col>

                <v-col cols="3">
                  <v-btn
                    @click="updateSearchTerm"
                    class="white--text"
                    color="#2c3e50"
                    >Filtrer</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <logradius-datatable
          :options="options"
          @update:options="options = $event"
          :firstLoad="firstLoad"
          :is-loading="isLoading"
          :logsradius="logsradius"
        ></logradius-datatable>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs, watch } from "@vue/composition-api";
import router from "../router";
import { useNas } from "../composables/nas";
import { useLogRadius } from "@/composables/logradius";
import LogradiusDatatable from "@/components/Logradius/LogradiusDatatable";
import { useTitle } from "@/composables/title";
export default {
  components: { LogradiusDatatable },
  setup() {
    const { setTitle } = useTitle();

    const { currentNas, showNas } = useNas();
    const { listLogradius, logsradius, logradiusData } = useLogRadius();
    const nasId = router.currentRoute.params.nasId;

    const datatableProxyFilters = reactive({
      username: "",
      clientIpAddress: "",
      callingStationId: "",
      accountStatusType: "",
      accountTerminateCause: "",
      replyPacketType: "",
      operation: "",
      createdAt: "",
    });

    watch(
      () => logradiusData.options,
      (newValues, oldValues) => {
        if (oldValues.page !== undefined) {
          listLogradius(currentNas.value.nasIdentifier, datatableProxyFilters);
        }
      },
      {
        deep: true,
      }
    );

    const updateSearchTerm = () => {
      listLogradius(currentNas.value.nasIdentifier, datatableProxyFilters);
    };

    onMounted(async () => {
      await showNas(nasId);
      if (currentNas.value != null) {
        setTitle(
          "Liste des logs radius pour le NAS : " +
            currentNas.value.nasIdentifier
        );
        listLogradius(currentNas.value.nasIdentifier);
      }
    });

    return {
      dateMenuRef: ref(null),
      dateMenu: ref(null),
      updateSearchTerm,
      currentNas,
      logsradius,
      ...toRefs(logradiusData),
      datatableProxyFilters,
    };
  },
};
</script>
